import React, { Component } from 'react';
import {
    Container,
    Card,
    CardHeader,
    Typography,
    CardContent,
    Grid,
} from '@material-ui/core';
import {
    Alert, Button, Spinner, Table,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { formatDate } from '../../Utils/formatDate';
import {RedemptionModeAPI} from '../../API';
import { PageStatus } from 'enums';
import { Show } from 'Layout';
import './MyRewards.css'
import {Form} from "./MyRequestForm";
import { dict } from '../../Languages/MyRequestsTranslations';
import country from 'config/countryConfig';

const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
    QUESTION: 'QUESTION'
};

class MyRequests extends Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            survey: [],
            total: 0,
            totalEarned: 0,
            totalRedeemed: 0,
            totalPendingRedeemed: 0,
            totalLeft: 0,
            status: PageStatus.None,
            error: null,
            showRequestWarning: false,
        };
    }

    componentDidMount() {
        if (this.props.userId) {
            this.fetchSurvey();
        }
        const body = document.querySelector('body');
        if(body !== null){
            body.removeAttribute('style');
        }

    }

    fetchSurvey = () => {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => RedemptionModeAPI.redemptionRequestListByUserId(10000, this.props.userId))
            .then((surveyData: any) => {
                if (surveyData) {
                    this.setState({
                        survey: surveyData.data,
                        totalEarned: surveyData.totalEarned,
                        totalRedeemed: surveyData.totalRedeemed,
                        totalPendingRedeemed: surveyData.totalPendingRedeemed,
                        totalLeft: surveyData.totalLeft,
                        status: PageStatus.Loaded
                    });
                }
            })
            .catch((err) => {
                this.setState({ error: err.message, status: PageStatus.Error });
            });
    };

    isAbleToCreateRequest() {
        if(this.state.totalLeft < country.minRedemptionPoints) {
            return this.setState({ showRequestWarning: true })
        } else {
            return this.setState({
                formType: MODAL_TYPES.CREATE,
            });
        }
    }
    render() {
        const { status } = this.state;
        const { t } = this.props;
        const lang = this.props.language ?? 'en';
        const checkTableContent = (value, type) => {
            if(value[type]){ return value[type]; }
            else if(value.redemptionRequestStatus === "Redeemed"){ return "Delivered"; }
            else { return "-" }
        }
        return (
            <div>
            <Container>
                <Show when={this.state.showRequestWarning}>
                    <Alert variant="danger" show={this.state.showRequestWarning}>
                        {t('requests.redeemPointsWarning', { min: country.minRedemptionPoints })}
                    </Alert>
                </Show>
                <Card className="mainCard">
                    <div className="d-flex align-items-center justify-content-between">
                        <h4 className='text-white cardTitle' >{t('requests.list.myRequestsHeading')}</h4>
                        <div>
                            <Button
                                onClick={() => {
                                    return this.isAbleToCreateRequest()
                                }}
                                variant="warning"
                                size="sm"
                                title={this.state.totalLeft < country.minRedemptionPoints ? t('requests.list.redeemPointsDisabledTooltip') : t('requests.list.createRequestTooltip')}
                                className="mx-1"
                            >
                                {t('requests.list.clickToRedeemButton')}
                            </Button>
                        </div>
                    </div>
                </Card>
                <Card className="nestedCard">
                    <CardContent>
                        <Grid container spacing={2} className="gridContainer">
                            <Grid item xs={6} sm={3} className="gridItem">
                                <Typography variant="h4">{this.state.totalEarned}</Typography>
                                <Typography variant="body1">{t('requests.list.totalPointsEarnedLabel')}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={3} className="gridItem">
                                <Typography variant="h4">{this.state.totalRedeemed}</Typography>
                                <Typography variant="body1">{t('requests.list.pointsRedeemedLabel')}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={3} className="gridItem">
                                <Typography variant="h4">{this.state.totalPendingRedeemed}</Typography>
                                <Typography variant="body1">{t('requests.list.pendingRedemptionsLabel')}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={3} className="gridItem">
                                <Typography variant="h4">{this.state.totalLeft}</Typography>
                                <Typography variant="body1">{t('requests.list.pointsLeftLabel')}</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Card className="nestedCard">
                    <Show when={status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>
                    <Show when={status === PageStatus.Loaded}>
                        <Show when={this.state.formType === MODAL_TYPES.CREATE}>
                            <Form
                                show={this.state.formType === MODAL_TYPES.CREATE}
                                userId={this.props.userId}
                                totalLeft={this.state.totalLeft || 0}
                                onClose={() => this.setState({ formType: MODAL_TYPES.NONE })}
                                onSubmit={(id) => {
                                    this.fetchSurvey();
                                    this.setState({ formType: MODAL_TYPES.NONE, id: id });
                                }}
                                language={lang}
                            />
                        </Show>
                        <CardHeader
                            title={t('requests.list.redemptionsRequestSummaryHeading')}
                            className="cardHeader"
                            titleTypographyProps={{ className: 'cardHeader' }}
                        />
                        <Show when={!this.state.survey.length}>
                            <CardContent>
                                <Typography variant="body1">{t('requests.list.noRedemptionsEmptyText')}</Typography>
                            </CardContent>
                        </Show>
                    </Show>
                    <Show when={status === PageStatus.Loaded}>
                        <Show when={!!this.state.survey.length}>
                            <Table responsive size="sm" bordered>
                                <thead>
                                    <tr>
                                        <th>{t('common.columnSerialNo')}</th>
                                        <th>{t('requests.list.tableColRequestedDate')}</th>
                                        <th>{t('requests.list.tableColMode')}</th>
                                        <th>{t('common.statusLabel')}</th>
                                        <th>{t('requests.list.tableColUser')}</th>
                                        <th>{t('requests.list.tableColPointsRequested')}</th>
                                        <th>{t('requests.list.pointsRedeemedLabel')}</th>
                                        <th>{t('requests.list.tableColPhoneNumber')}</th>
                                        <th>{t('requests.list.tableColCouponCode')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.survey.map((redemption, index) => (
                                        <tr key={"surveyAArr" + index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {redemption ? formatDate(redemption.requestDate) : '-'}
                                            </td>
                                            <td>{redemption.redemptionModeTitle}</td>
                                            <td>{redemption.redemptionRequestStatus == "Pending(Finance)" ? "New" : redemption.redemptionRequestStatus}</td>
                                            <td>
                                                {redemption.user ? redemption.user.email : '-'}
                                            </td>
                                            <td>
                                                {redemption.pointsRequested}
                                            </td>
                                            <td>
                                                {redemption.pointsRedeemed}
                                            </td>
                                            <td>
                                                {redemption.user ? redemption.user.phoneNumber : '-'}
                                            </td>
                                            <td>
                                                {checkTableContent(redemption, "coupon")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Show>
                    </Show>
                </Card>
            </Container>
        </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        userId: state.adminUser.adminUser.userId,
        role: state.adminUser.adminUser.role,
        phoneNumber: state.adminUser.adminUser.phoneNumber,
        email: state.adminUser.adminUser.email,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
        language: state.adminUser.adminUser.language,
    };
};

export default connect(mapStateToProps)(withTranslation()(MyRequests));
